var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-table-column',{attrs:{"label":"审核操作","prop":"log.status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.log.status === 'Pass')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("审核通过")]):_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("审核拒绝")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }